
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function FinalCTASection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="py-20 sm:py-32 bg-gradient-to-b from-dark to-navy-dark relative overflow-hidden">
      {/* Animated gradient orbs */}
      <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-secondary/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute top-1/2 right-1/4 w-80 h-80 bg-primary/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      <div ref={sectionRef} className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h2 
          className={`text-2xl sm:text-4xl md:text-5xl font-bold leading-tight mb-8 sm:mb-12 transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Você não precisa de mais esforço.
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-accent-cyan to-secondary">Precisa de um sistema.</span>
        </h2>

        <a
          href="https://pay.kiwify.com.br/rnRjiX5"
          target="_blank"
          rel="noopener noreferrer"
          className={`inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-primary to-accent-cyan text-dark text-sm sm:text-lg font-bold rounded-xl shadow-2xl shadow-primary/40 transition-all hover:scale-105 cursor-pointer whitespace-nowrap ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '200ms', transitionDuration: '700ms' }}
        >
          <span className="hidden sm:inline">Quero Minha IA Trabalhando Para Mim</span>
          <span className="sm:hidden">Quero Minha IA Agora</span>
          <i className="ri-arrow-right-line text-xl sm:text-2xl"></i>
        </a>

        <p 
          className={`mt-6 sm:mt-8 text-gray-400 text-xs sm:text-base transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '400ms' }}
        >
          Implementação gratuita • Suporte incluído • Entrega no mesmo dia
        </p>
      </div>
    </section>
  );
}
